import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CompanyPage from "./pages/Comapny";
import ContactPage from "./pages/ContactPage";
import Gallery from "./pages/Gallery";
import AdminLogin from "./admin/Login";
import AdminDashboard from "./admin/Dashboard";
import ProtectedRoute from "./admin/ProtectedRoute";
import HomePage from "./pages/HomeNew";
import CompanyPageNew from './pages/CompanyNew'
// add other pages...

/** */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/homeold" element={<Home />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/cn/:slug" element={<CompanyPageNew />} />
        <Route path="/company/:id" element={<CompanyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        {/* more routes */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
